export enum ClipState {
    NotInClip = 1,
    StartClipAndSelectPosition = 2,
    InClip = 3,
    EndClipAndSelectPosition = 4,
}